import Select from "react-dropdown-select";
import React from "react";

export default function UpdatePI({
                                     handleSubmit,
                                     handleChange,
                                     handleBlur,
                                     error,
                                     registering,
                                     stores,
                                     defaultStore,
                                     handleStoreChange,
                                     cosmosCustomer, comparisonSummary
                                 }) {
    const isDisabled = !comparisonSummary || registering;

    const disableReason = !comparisonSummary
        ? "* Cannot be updated because of data discrepancy"
        : registering
            ? "Updating account in progress..."
            : "";

    return (
        <div>
            <h4
                id="sub_head"
                style={{
                    fontFamily: "A Love of Thunder",
                    color: "#007935",
                    marginBottom: "10px"
                }}
            >
                Update profile
            </h4>
            <form onSubmit={handleSubmit}>

                <h6 id="note">All fields required *</h6>
                <div className="row">
                    <div className="col-12">
                        <div className="form-group">
                            <input
                                type="text"
                                name="customerId"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Customer ID *"
                                id="customerId"
                                value={cosmosCustomer?.id || ""}
                                disabled
                            />
                            <div className="text-danger">{error.customerId}</div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <input
                                type="text"
                                name="firstName"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="First Name *"
                                id="firstName"
                                value={cosmosCustomer?.firstName || ""}
                            />
                            <div className="text-danger">{error.firstName}</div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="form-group">
                            <input
                                type="text"
                                name="lastName"
                                onChange={handleChange}
                                className="form-control"
                                placeholder="Last Name *"
                                id="lastName"
                                value={cosmosCustomer?.lastName || ""}
                            />
                            <div className="text-danger">{error.lastName}</div>
                        </div>
                    </div>
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        name="email"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Email *"
                        id="email"
                        value={cosmosCustomer?.email || ""}
                    />
                    <div className="text-danger">{error.email}</div>
                </div>
                <div className="form-group">
                    <input
                        type="number"
                        name="phoneNo"
                        onChange={handleChange}
                        className="form-control"
                        placeholder="Primary Phone Number *"
                        id="phoneNo"
                        value={cosmosCustomer?.phoneNo || ""}
                    />
                    <div className="text-danger">{error.phoneNo}</div>
                </div>
                <div className="form-group">
                    <input
                        type="text"
                        name="birthday"
                        className="form-control"
                        placeholder="Date of Birth (MM/DD/YYYY)"
                        id="birthday"
                        value={cosmosCustomer?.birthday || ""}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    />
                    <div
                        className={error.birthday ? "text-danger" : "text-success"}>{error.birthday ? error.birthday : error.birthdaySuccess}</div>
                </div>
                <div className="form-group">
                    {stores.length > 0 && defaultStore ?
                        <Select style={{border: "2px solid #000", borderRadius: "0"}}
                                onChange={values => handleStoreChange(values)}
                                options={stores}
                                dropdownHeight="350px"
                                labelField="ecomName"
                                valueField="ecomName"
                                name="storeLocation"
                                placeholder="Select Store *"
                                values={[defaultStore] || ""}/> :
                        <Select style={{border: "2px solid #000", borderRadius: "0"}}
                                onChange={values => handleStoreChange(values)}
                                options={stores}
                                dropdownHeight="350px"
                                labelField="ecomName"
                                valueField="ecomName"
                                name="storeLocation"
                                placeholder="Select Store *"
                        />}
                    <div className="text-danger">{error.storeLocation}</div>
                </div>
                <button
                    id="sub_btn"
                    type="submit"
                    disabled={isDisabled}
                    title={isDisabled ? disableReason : ""}
                    style={{
                        backgroundColor: isDisabled ? "#cccccc" : "#007935",
                        color: isDisabled ? "#666666" : "#ffffff",
                        height: "35px",
                        fontSize: "1.2em",
                        cursor: isDisabled ? "not-allowed" : "pointer",
                        opacity: isDisabled ? 0.7 : 1
                    }}
                >
                    Update Account{" "}
                    {registering ? <i className="fa fa-spinner fa-spin" /> : ""}
                </button>
                {isDisabled && (
                    <div
                        style={{
                            color: "#b00020",
                            marginTop: "6px",
                            fontSize: "0.85em",
                            textAlign: "center",
                            width: "100%"
                        }}
                    >
                        {disableReason}
                    </div>
                )}
            </form>
        </div>);
}